import React from "react";
import { NavLink } from "react-router";
import styled from "styled-components";

const NavList = styled.ul`
  display: flex;
  margin: ${({ theme }) => theme.space[2]};
  padding-inline-start: 0;
  padding: 0.2rem;
  border: 0.5px solid ${({ theme }) => theme.colors.grey24};
  border-radius: ${({ theme }) => theme.radii[1]};
  background-color: ${({ theme }) => theme.colors.white4};
  list-style-type: none;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-inline-end: 20%;
    margin-inline-start: 20%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[5]}) {
    margin-inline-end: 30%;
    margin-inline-start: 30%;
  }
`;

const NavItem = styled.li`
  flex: 1;
`;

const StyledNavLink = styled(NavLink)`
  display: block;
  padding: ${({ theme }) => theme.space[2]};
  border-radius: ${({ theme }) => theme.radii[1]};
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.5rem;
  text-decoration: none;
  text-align: center;

  &.active {
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.white};
    font-weight: bold;
  }
`;

interface ILinks {
  href: string;
  text: string;
}

interface ISubNav {
  links: ILinks[];
}

const SubNav: React.FC<ISubNav> = ({ links }) => (
  <nav>
    <NavList>
      {links.map((l) => (
        <NavItem key={l.href}>
          <StyledNavLink to={l.href} end>
            {l.text}
          </StyledNavLink>
        </NavItem>
      ))}
    </NavList>
  </nav>
);

export default SubNav;
